export default function Close(props: any) {
    const { id = '', ...rest } = props;
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M13 13L35 35" stroke={`url(#${id ? `paint0_linear_947_1877_${id}` : 'paint0_linear_947_1877'}`} strokeWidth="2" />
            <path d="M35 13L13 35" stroke={`url(#${id ? `paint1_linear_947_1877_${id}` : 'paint1_linear_947_1877'}`} strokeWidth="2" />
            <defs>
                <linearGradient
                    id={`${id ? `paint0_linear_947_1877_${id}` : 'paint0_linear_947_1877'}`}
                    x1="22.4735"
                    y1="6.08972"
                    x2="36.6668"
                    y2="6.53009"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient
                    id={`${id ? `paint1_linear_947_1877_${id}` : 'paint1_linear_947_1877'}`}
                    x1="25.5265"
                    y1="6.08972"
                    x2="11.3332"
                    y2="6.53009"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
            </defs>
        </svg>
    );
}
